import { render, staticRenderFns } from "./EditorInformation.vue?vue&type=template&id=b32b7822&scoped=true&"
import script from "./EditorInformation.vue?vue&type=script&lang=js&"
export * from "./EditorInformation.vue?vue&type=script&lang=js&"
import style0 from "./EditorInformation.vue?vue&type=style&index=0&id=b32b7822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32b7822",
  null
  
)

export default component.exports